import React, { FC, useState } from 'react';

import { Block as BlockIcon } from '@mui/icons-material';
import { Box, Button, Dialog, DialogContent, MenuItem, Select, Typography } from '@mui/material';
import { ConfigurationStatus } from '@prisma/client';
import { BsX } from 'react-icons/bs';

import { useQuery } from '@redwoodjs/web';

import StatusChip from 'src/components/UserStatusChip/UserStatusChip';
import { GET_SUSPENDED_REASONS } from 'src/graphql/queries/suspendedReasons.query';
interface SuspendModalProps {
    handleSuspendPartner: () => void;
    isModalOpen: boolean;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    suspendReason: string;
    setSuspendReason: React.Dispatch<React.SetStateAction<string>>;
}

export const SuspendModal: FC<SuspendModalProps> = ({
    handleSuspendPartner,
    setIsModalOpen,
    isModalOpen,
    setSuspendReason,
    suspendReason,
}) => {
    const [activeSuspendReasons, setActiveSuspendReasons] = useState(null);

    const { loading: loadingSuspendedReasonsData } = useQuery(GET_SUSPENDED_REASONS, {
        variables: {
            filter: {
                status: ConfigurationStatus.ACTIVE,
            },
        },
        onCompleted: (data) => {
            const reasonDescriptionsList = data.suspendedReasons.map(
                (reason) => reason.description
            );
            setActiveSuspendReasons(reasonDescriptionsList);
        },
    });
    const handleCloseSuspendModal = () => {
        setIsModalOpen(false);
    };

    const handleSuspendReasonsDropDownChange = (event) => {
        setSuspendReason(event.target.value);
    };

    return (
        <Dialog
            open={isModalOpen}
            onClose={handleCloseSuspendModal}
            aria-labelledby="send-pdf-modal"
            sx={{
                '& .MuiPaper-root': {
                    margin: '0px',
                    padding: '0px',
                    borderRadius: '16px',
                },
            }}
        >
            <Box
                sx={{
                    background: 'linear-gradient(90deg, #FF8008, #FFC837)',
                    height: '82px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '24px',
                }}
            >
                <Typography color="white" variant="h2">
                    Suspend Partner
                </Typography>
                <Button
                    variant="outlined"
                    startIcon={<BsX width="24px" height="24px" />}
                    onClick={handleCloseSuspendModal}
                    sx={{
                        color: '#F39E4E',
                        minWidth: '32px !important',
                        width: '32px',
                        height: '32px',
                        padding: '0px',
                        borderRadius: '50%',
                        backgroundColor: 'white',
                        border: '1px solid #F39E4E',
                        '& span': {
                            marginRight: '0px',
                            marginLeft: '0px',
                        },
                        '&:hover': {
                            backgroundColor: '#eee !important',
                        },
                        boxShadow: 'none',
                    }}
                />
            </Box>
            <DialogContent>
                <Box
                    sx={{
                        display: 'flex',
                        gap: '16px',
                        flexDirection: 'column',
                        width: '100%',
                    }}
                >
                    <Typography>Select a suspension reason: </Typography>
                    <Select
                        fullWidth
                        sx={{
                            color: '#F18F34',
                            bgcolor: 'white',
                            height: '40px',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                        value={suspendReason}
                        onChange={handleSuspendReasonsDropDownChange}
                        name="suspendPartner"
                    >
                        {activeSuspendReasons?.map((status) => (
                            <MenuItem value={status} key={status} sx={{ alignSelf: 'center' }}>
                                <StatusChip type="user" status={status} />
                            </MenuItem>
                        ))}
                    </Select>
                    <Button
                        variant="contained"
                        startIcon={<BlockIcon />}
                        onClick={handleSuspendPartner}
                        sx={{ color: 'white' }}
                        disabled={!suspendReason}
                    >
                        Suspend
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default SuspendModal;
